import { api } from '../../api'
import { TeacherTypes } from './Teachers.types'

const revokeLicense = async (
  teacherIdOrIds: TeacherTypes['id'] | TeacherTypes['id'][]
) => {
  const teacherIds = Array.isArray(teacherIdOrIds)
    ? teacherIdOrIds
    : [teacherIdOrIds]

  const teacherIdsAsString = teacherIds.flatMap((teacherId) =>
    String(teacherId)
  )

  const response = await api.put<TeacherTypes>(
    `/teachers/revokeLicenses`,
    teacherIdsAsString
  )

  return response.data
}

export default revokeLicense
